import TagIcon from '@material-ui/icons/LocalOffer'
import TagsManagement from './TagsManagement'
import List from './List'
import Create from './Create'
import Edit from './Edit'

export default {
  list: TagsManagement,
  edit: Edit,
  show: Edit,
  create: Create,
  icon: TagIcon,
}

